/* Siddhambika Luxe — theme scripts (no dependencies) */
(function () {
  'use strict';

  var theme = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  document.documentElement.classList.remove('no-js');

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '₹{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  theme.formatMoney = formatMoney;

  /* ---------- Header scroll state ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawers & modals ---------- */
  var lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input, select');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openLayer(document.getElementById(opener.getAttribute('data-open')));
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      closeLayer(closer.closest('.drawer, .search-modal'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open, .search-modal.is-open').forEach(closeLayer);
  });

  /* ---------- Predictive search ---------- */
  var searchInput = $('#SearchModalInput');
  var searchResults = $('#SearchModalResults');
  if (searchInput && searchResults) {
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(theme.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="meta">No products found for “' + escapeHtml(q) + '”.</p>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
              return '<a class="search-results__item" href="' + p.url + '">' +
                (src ? '<img src="' + src + '" alt="" width="56" height="56" loading="lazy">' : '') +
                '<div><div class="search-results__title">' + escapeHtml(p.title) + '</div>' +
                '<div class="search-results__price">From ' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</div></div></a>';
            }).join('') + '<a class="link-arrow" href="' + theme.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">View all results</a>';
          })
          .catch(function () { searchResults.innerHTML = ''; });
      }, 220);
    });
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px 20% 0px', threshold: 0 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
    // Safety net: never leave content hidden if the observer is throttled.
    setTimeout(function () { $$('.reveal:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight * 1.5) el.classList.add('is-in'); }); }, 1800);
    window.addEventListener('scroll', function () { clearTimeout(window.__rv); window.__rv = setTimeout(function () { $$('.reveal:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 400); }, { passive: true });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var buttons = $$('[role="tab"]', wrap);
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on);
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  });

  /* ---------- Cart helpers ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  function refreshCart() {
    return fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      return cart;
    });
  }

  var toast = $('#Toast');
  var toastTimer;
  function showToast(item) {
    if (!toast) return;
    var timg = $('[data-toast-img]', toast);
    if (item.image) { timg.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120'; } else { timg.removeAttribute('src'); }
    $('[data-toast-title]', toast).textContent = item.product_title + (item.variant_title ? ' · ' + item.variant_title : '');
    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4500);
  }
  function hideToast() { if (!toast) return; toast.classList.remove('is-visible'); toast.setAttribute('aria-hidden', 'true'); }
  if (toast) $('[data-toast-close]', toast).addEventListener('click', hideToast);

  /* AJAX add to cart for any form[data-ajax-cart] */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Theme-Request': '1' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
        showToast(res.json);
        return refreshCart();
      })
      .catch(function (err) { alert(err.message); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- Product card: weight pills update price ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('[data-card-variant]')) return;
    var card = input.closest('.card');
    var price = card && card.querySelector('[data-card-price]');
    if (price) {
      var compare = parseInt(input.getAttribute('data-compare') || '0', 10);
      var now = parseInt(input.getAttribute('data-price'), 10);
      price.innerHTML = '<span class="price__now">' + formatMoney(now) + '</span>' +
        (compare > now ? '<s class="price__compare">' + formatMoney(compare) + '</s>' : '');
      price.classList.toggle('price--sale', compare > now);
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + (b.getAttribute('data-qty') === 'plus' ? 1 : -1);
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-product-json]', root);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = $('form[data-ajax-cart]', root);
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = $('[data-price]', root);
    var stockEl = $('[data-stock]', root);
    var addBtns = $$('[data-add-button]', document);
    var stickyPrice = $('[data-sticky-price]');
    var gallery = $('.gallery__main', root);

    function currentOptions() {
      return $$('[data-option-index]', root).map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      $$('[data-option-index]', root).forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var label = group.querySelector('legend span');
        if (checked && label) label.textContent = checked.value;
      });
      var v = findVariant(currentOptions());
      if (!v) {
        addBtns.forEach(function (b) { b.disabled = true; $('.btn__label', b).textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = v.id;
      var compare = v.compare_at_price && v.compare_at_price > v.price;
      var html = '<span class="price__now">' + formatMoney(v.price) + '</span>' +
        (compare ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s><span class="badge badge--gold" style="position:static">Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>' : '');
      if (priceEl) { priceEl.innerHTML = html; priceEl.classList.toggle('price--sale', !!compare); }
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price) + (v.title !== 'Default Title' ? ' · ' + v.title : '');
      addBtns.forEach(function (b) {
        b.disabled = !v.available;
        $('.btn__label', b).textContent = v.available ? 'Add to cart' : 'Sold out';
      });
      if (stockEl) {
        stockEl.textContent = v.available ? 'In stock, ready to ship' : 'Currently out of stock';
        stockEl.classList.toggle('stock--out', !v.available);
      }
      if (v.featured_media && gallery) {
        var slide = gallery.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });

    /* Sticky add-to-cart on mobile */
    var sticky = $('[data-sticky-atc]');
    var mainBtn = $('[data-add-button]', root);
    if (sticky && mainBtn) {
      // Show the bar only once the main Add to cart button has scrolled above the screen
      var syncSticky = function () {
        sticky.classList.toggle('is-visible', mainBtn.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
      var stickyBtn = $('[data-sticky-submit]', sticky);
      if (stickyBtn) stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : mainBtn.click(); });
    }
  });

  /* ---------- Gallery (dots + thumbs) ---------- */
  $$('.gallery').forEach(function (g) {
    var track = $('.gallery__main', g);
    var dots = $$('.gallery__dots button', g);
    var thumbs = $$('.gallery__thumbs button', g);
    function setActive(i) {
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
    }
    function goTo(i) {
      var s = track.children[i];
      if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    dots.concat(thumbs).forEach(function (b) {
      b.addEventListener('click', function () { goTo(parseInt(b.getAttribute('data-index'), 10)); });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
  });

  /* ---------- Cart page: live quantity updates ---------- */
  var cartRoot = $('[data-cart-section]');
  if (cartRoot) {
    var sectionId = cartRoot.getAttribute('data-cart-section');
    var busy = false;
    function changeLine(line, qty) {
      if (busy) return;
      busy = true;
      cartRoot.style.opacity = '0.6';
      fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Theme-Request': '1' },
        body: JSON.stringify({ line: line, quantity: qty, sections: [sectionId], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.sections && cart.sections[sectionId]) {
            var doc = new DOMParser().parseFromString(cart.sections[sectionId], 'text/html');
            var fresh = doc.querySelector('[data-cart-section]');
            if (fresh) cartRoot.innerHTML = fresh.innerHTML;
          } else {
            window.location.reload();
          }
          updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { busy = false; cartRoot.style.opacity = ''; });
    }
    cartRoot.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line]');
      if (input) changeLine(parseInt(input.getAttribute('data-line'), 10), parseInt(input.value, 10));
    });
    cartRoot.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove-line]');
      if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-remove-line'), 10), 0); }
    });
  }

  /* ---------- Collection: auto-submit sort ---------- */
  $$('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* ---------- Related products (recommendations) ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) {
        el.innerHTML = fresh.innerHTML;
        $$('.reveal', el).forEach(function (r) { r.classList.add('is-in'); });
      }
    });
  });

  /* ---------- Footer: groups collapse on phones, always open on desktop ---------- */
  var footerMq = window.matchMedia('(min-width: 900px)');
  function syncFooter() { $$('[data-footer-col]').forEach(function (d) { d.open = footerMq.matches; }); }
  syncFooter();
  if (footerMq.addEventListener) footerMq.addEventListener('change', syncFooter);

  /* ---------- Reviews: swipe dots on phones ---------- */
  $$('[data-reviews-track]').forEach(function (track) {
    var dots = $$('[data-reviews-dots] i', track.closest('section'));
    if (!dots.length) return;
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var best = 0, min = 1e9;
        Array.prototype.forEach.call(track.children, function (card, i) {
          var d = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < min) { min = d; best = i; }
        });
        dots.forEach(function (dot, i) { dot.classList.toggle('on', i === best); });
      });
    }, { passive: true });
  });

  /* ---------- Reviews: form hidden behind 'Write a review' button ---------- */
  $$('[data-review-form]').forEach(function (form) {
    var section = form.closest('section');
    var hasResult = form.querySelector('.review-form__ok, .errors');
    var openers = $$('[data-open-review]', section);
    function setExpanded(v) { openers.forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }
    if (!hasResult && window.location.hash !== '#write-review') { form.classList.add('is-collapsed'); setExpanded(false); } else { setExpanded(true); }
    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var wasCollapsed = form.classList.contains('is-collapsed');
        form.classList.remove('is-collapsed');
        form.classList.add('is-in');
        if (wasCollapsed) { form.classList.add('is-opening'); }
        setExpanded(true);
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var first = form.querySelector('.star-input label');
        if (first) setTimeout(function () { var inp = document.getElementById(first.getAttribute('for')); if (inp) inp.focus({ preventScroll: true }); }, 500);
      });
    });
  });

  /* ---------- Keep cart badge in sync when other scripts (Razorpay side cart) change the cart ---------- */
  var syncTimer;
  function scheduleCartSync() { clearTimeout(syncTimer); syncTimer = setTimeout(function () { refreshCart().catch(function () {}); }, 600); }
  function isCartWrite(url) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || '')); }
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = nativeFetch.apply(this, arguments);
      if (isCartWrite(url) && !(init && init.headers && init.headers['X-Theme-Request'])) p.then(scheduleCartSync, function () {});
      return p;
    };
  }
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) this.addEventListener('loadend', scheduleCartSync);
    return nativeOpen.apply(this, arguments);
  };
  document.addEventListener('visibilitychange', function () { if (!document.hidden) scheduleCartSync(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleCartSync(); });

  /* ---------- Buy Now: reveal once Razorpay has swapped in its button (no flicker) ---------- */
  $$('[data-buy-now]').forEach(function (wrap) {
    var done = false;
    function ready() { if (done) return; done = true; wrap.classList.add('is-ready'); if (obs) obs.disconnect(); }
    function check() {
      if (wrap.querySelector('magic-checkout-btn, .magic-buy-btn')) return ready();
      var magicOn = document.getElementById('magic-checkout-data-container');
      // No Razorpay on the page: show Shopify's own button as soon as it renders
      if (!magicOn && wrap.querySelector('.shopify-payment-button__button')) ready();
    }
    var obs = 'MutationObserver' in window ? new MutationObserver(check) : null;
    if (obs) obs.observe(wrap, { childList: true, subtree: true });
    check();
    // Safety net: never leave the button hidden if Razorpay is slow or blocked
    setTimeout(ready, 4000);
  });

  /* ---------- Pincode delivery check (real Shopify shipping rates) ---------- */
  $$('[data-pincode]').forEach(function (box) {
    var form = $('[data-pin-form]', box), input = $('[data-pin-input]', box), out = $('[data-pin-out]', box), btn = $('[data-pin-btn]', box);
    var MIN = +box.dataset.min || 4, MAX = +box.dataset.max || 5, CARRIER = box.dataset.carrier || 'Delhivery', FREE = +box.dataset.free || 0;
    var HDR = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Theme-Request': '1' };
    var token = 0;
    function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    function plusDays(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
    function fmt(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
    function dateRange() { return fmt(plusDays(MIN)) + ' – ' + fmt(plusDays(MAX)); }
    function selected() {
      var f = document.getElementById('ProductForm');
      var id = f && f.querySelector('input[name="id"]');
      var q = document.getElementById('Qty');
      return { id: id ? +id.value : 0, qty: q ? (+q.value || 1) : 1 };
    }
    // Indian postal zones -> Shopify state codes (needed for shipping rates)
    function stateFor(pin) {
      var p3 = +pin.slice(0, 3), p2 = +pin.slice(0, 2);
      var exact3 = { 160: 'CH', 194: 'LA', 403: 'GA', 605: 'PY', 607: 'PY', 609: 'PY', 682: 'KL', 737: 'SK', 744: 'AN', 790: 'AR', 791: 'AR', 792: 'AR', 793: 'ML', 794: 'ML', 795: 'MN', 796: 'MZ', 797: 'NL', 798: 'NL', 799: 'TR', 246: 'UK', 247: 'UK', 248: 'UK', 249: 'UK', 262: 'UK', 263: 'UK', 396: 'GJ' };
      if (exact3[p3]) return exact3[p3];
      if (p3 >= 813 && p3 <= 835 && [814, 815, 816, 822, 825, 826, 827, 828, 829, 831, 832, 833, 834, 835].indexOf(p3) > -1) return 'JH';
      if (p3 >= 490 && p3 <= 497) return 'CG';
      if (p3 >= 500 && p3 <= 509) return 'TS';
      var by2 = { 11: 'DL', 12: 'HR', 13: 'HR', 14: 'PB', 15: 'PB', 16: 'PB', 17: 'HP', 18: 'JK', 19: 'JK', 30: 'RJ', 31: 'RJ', 32: 'RJ', 33: 'RJ', 34: 'RJ', 36: 'GJ', 37: 'GJ', 38: 'GJ', 39: 'GJ', 40: 'MH', 41: 'MH', 42: 'MH', 43: 'MH', 44: 'MH', 45: 'MP', 46: 'MP', 47: 'MP', 48: 'MP', 49: 'CG', 51: 'AP', 52: 'AP', 53: 'AP', 56: 'KA', 57: 'KA', 58: 'KA', 59: 'KA', 60: 'TN', 61: 'TN', 62: 'TN', 63: 'TN', 64: 'TN', 67: 'KL', 68: 'KL', 69: 'KL', 70: 'WB', 71: 'WB', 72: 'WB', 73: 'WB', 74: 'WB', 75: 'OR', 76: 'OR', 77: 'OR', 78: 'AS', 79: 'AS', 80: 'BR', 81: 'BR', 82: 'BR', 83: 'BR', 84: 'BR', 85: 'BR' };
      if (p2 >= 20 && p2 <= 28) return 'UP';
      return by2[p2] || '';
    }
    function addr(pin) { var s = stateFor(pin); return 'shipping_address[zip]=' + pin + '&shipping_address[country]=IN' + (s ? '&shipping_address[province]=' + s : ''); }
    function rates(pin) {
      var tempKey = null;
      return fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (cart.item_count) return;
        var s = selected();
        if (!s.id) return;
        return fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: HDR, body: JSON.stringify({ id: s.id, quantity: s.qty }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function (item) { tempKey = item.key; });
      }).then(function () {
        return fetch('/cart/prepare_shipping_rates.json?' + addr(pin), { method: 'POST', headers: { 'X-Theme-Request': '1' } });
      }).then(function () {
        var n = 0;
        function poll() {
          return fetch('/cart/async_shipping_rates.json?' + addr(pin)).then(function (r) {
            if (r.status === 200) return r.json();
            if (r.status >= 400 && r.status !== 404) return r.json().then(function (e) { return { error: e }; });
            if (++n > 10) throw new Error('timeout');
            return sleep(600).then(poll);
          });
        }
        return poll();
      }).then(function (d) { cleanup(); return d; }, function (e) { cleanup(); throw e; });
      function cleanup() {
        if (tempKey) fetch(theme.routes.cartChange + '.js', { method: 'POST', headers: HDR, body: JSON.stringify({ id: tempKey, quantity: 0 }) });
      }
    }
    function line(icon, title, sub, cls) {
      return '<div class="pin__line"><span class="pin__ic">' + icon + '</span><div><b' + (cls ? ' class="' + cls + '"' : '') + '>' + title + '</b>' + (sub ? '<small>' + sub + '</small>' : '') + '</div></div>';
    }
    var IC = {
      ok: '<svg viewBox="0 0 24 24" class="icon"><path d="m5 12 5 5 9-10"/></svg>',
      cal: '<svg viewBox="0 0 24 24" class="icon"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>',
      rupee: '<svg viewBox="0 0 24 24" class="icon"><path d="M7 5h10M7 9h10M7 5c5 0 7 1.5 7 4s-2 4-7 4l7 7"/></svg>',
      truck: '<svg viewBox="0 0 24 24" class="icon"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
      no: '<svg viewBox="0 0 24 24" class="icon"><path d="M6 6l12 12M18 6 6 18"/></svg>'
    };
    function change() { return '<button type="button" class="pin__change" data-pin-change>Change pincode</button>'; }
    function check(pin) {
      if (!/^[1-9][0-9]{5}$/.test(pin)) { out.innerHTML = '<p class="pin__err">Please enter a valid 6-digit pincode.</p>'; input.focus(); return; }
      var my = ++token;
      try { localStorage.setItem('sb_pin', pin); } catch (e) {}
      btn.classList.add('is-loading'); btn.disabled = true;
      out.innerHTML = '<p class="pin__wait">Checking delivery to <b>' + pin + '</b>…</p>';
      var result = Promise.race([
        rates(pin).then(function (d) { return { d: d }; }, function () { return { err: true }; }),
        sleep(8000).then(function () { return { err: true }; })
      ]);
      Promise.all([result, sleep(700)]).then(function (res) {
        if (my !== token) return;
        btn.classList.remove('is-loading'); btn.disabled = false;
        var r = res[0], list = (r.d && r.d.shipping_rates) || [];
        if (!r.err && r.d && !r.d.error && list.length === 0) {
          out.innerHTML = '<div class="pin__res">' + line(IC.no, 'Sorry, we don’t deliver to ' + pin + ' yet', 'Try another pincode or contact us on WhatsApp.', 'pin__bad') + '</div>' + change();
          return;
        }
        var charge, chargeSub;
        if (list.length) {
          var best = list.reduce(function (a, b) { return parseFloat(b.price) < parseFloat(a.price) ? b : a; });
          var price = parseFloat(best.price);
          charge = price === 0 ? 'Free delivery' : 'Delivery charge ₹' + (price % 1 ? price.toFixed(2) : price);
          chargeSub = price === 0 ? 'No shipping charge for this order' : (FREE > 0 ? 'Free on orders above ₹' + FREE : 'Shown again at checkout');
        } else {
          charge = 'Delivery charge shown at checkout';
          chargeSub = FREE > 0 ? 'Free on orders above ₹' + FREE : '';
        }
        out.innerHTML = '<div class="pin__res">' +
          line(IC.ok, (list.length ? 'Delivery available to ' : 'Delivering to ') + pin, '', 'pin__good') +
          line(IC.cal, dateRange(), 'Expected delivery date') +
          line(IC.rupee, charge, chargeSub) +
          line(IC.truck, 'Shipped with ' + CARRIER, 'Our delivery partner') +
          '<p class="pin__note">Dates can shift slightly during festivals or bad weather.</p></div>' + change();
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); check(input.value.trim()); });
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
    out.addEventListener('click', function (e) {
      if (e.target.closest('[data-pin-change]')) { token++; out.innerHTML = ''; input.value = ''; input.focus(); }
    });
    try { var saved = localStorage.getItem('sb_pin'); if (saved) input.value = saved; } catch (e) {}
  });

  window.theme = theme;
})();
